import React from "react";
import { baseText } from "../_base";

const UnknownSubmission = () => <div style={baseText}>—</div>;

export default UnknownSubmission;
